'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Creates a flexbox context to control layout of children.
 */

var Flex = function Flex(_ref, _ref2) {
  var wrap = _ref.wrap;
  var column = _ref.column;
  var align = _ref.align;
  var justify = _ref.justify;
  var auto = _ref.auto;

  var props = _objectWithoutProperties(_ref, ['wrap', 'column', 'align', 'justify', 'auto']);

  var reflexbox = _ref2.reflexbox;

  var display = 'flex';

  var _config$reflexbox = _extends({}, _config2.default, reflexbox);

  var breakpoints = _config$reflexbox.breakpoints;


  if (typeof window !== 'undefined') {
    Object.keys(breakpoints).forEach(function (key) {
      if (Object.keys(props).indexOf(key) > -1) {
        display = 'block';
      }
    });
    Object.keys(breakpoints).forEach(function (key) {
      if (props[key] && window.matchMedia(breakpoints[key]).matches) {
        display = 'flex';
      }
    });
  }

  Object.keys(breakpoints).forEach(function (key) {
    delete props[key];
  });

  var sx = (0, _objectAssign2.default)(display ? { display: display } : null, wrap ? { flexWrap: 'wrap' } : null, column ? { flexDirection: 'column' } : null, auto ? { flex: '1 1 auto' } : null, align ? { alignItems: align } : null, justify ? { justifyContent: justify } : null);

  return _react2.default.createElement(_Base2.default, _extends({}, props, {
    _style: sx,
    _className: 'Flex' }));
};

Flex.propTypes = {
  /** Sets flex-wrap: wrap */
  wrap: _react2.default.PropTypes.bool,
  /** Sets flex-direction: column */
  column: _react2.default.PropTypes.bool,
  /** Sets negative left and right margins to compensate for <Box /> padding */
  gutter: _react2.default.PropTypes.number,
  /** Sets align-items */
  align: _react2.default.PropTypes.oneOf(['stretch', 'center', 'baseline', 'flex-start', 'flex-end']),
  /** Sets justify-content */
  justify: _react2.default.PropTypes.oneOf(['center', 'space-around', 'space-between', 'flex-start', 'flex-end']),
  /** Sets flex: 1 1 auto */
  auto: _react2.default.PropTypes.bool,
  /** Passes in a custom element or component */
  is: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object, _react2.default.PropTypes.func])
};

Flex.contextTypes = {
  reflexbox: _react2.default.PropTypes.shape({
    breakpoints: _react2.default.PropTypes.object,
    scale: _react2.default.PropTypes.array
  })
};

exports.default = Flex;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reflexbox/dist/Flex.js
 ** module id = 169
 ** module chunks = 0
 **/